<template>
  <button
    v-if="onlineMenuEnabled"
    class="btn btn-block
            add-to-cart animate__animated animate__fadeIn"
    @click="$emit('checkout')"
  >
    <div class="details-container"><span class="d-block">Checkout <span>| <span class="font-weight-bold">{{ rawMenu.user.currency.symbol
                                }}{{ orderAmount+tipAmount | centsToDollars }}</span></span></span>
      <div class="cart-count">{{ cartItemCount }}</div>
    </div>
  </button>
  <button
    :to="{
                name: 'menuIndex',
                params: { userSlug: rawMenu.user.slug },
              }"
    @click="closeModals()"
    class="btn btn-block
            add-to-cart closed animate__animated animate__fadeIn"
    v-else
  >
    <div class="details-container"><span class="d-block">Store closed</span>

    </div>
  </button>
</template>

<style lang="scss" scoped>
.add-to-cart {
  text-align: center;
  font-weight: 600;
  color: #fff;
  padding: 1rem;
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
  cursor: pointer;
  border-radius: 10rem;
  font-size: 1.3rem;
  &.closed {
    background-color: #ccc;
    border-color: #ccc;
    color: #000;
  }
}
.details-container {
  position: relative;
}
.cart-count {
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
  color: var(--user-highlight-color);
  width: 2rem;
  height: 2rem;
  background-color: #fff;
  border-color: #fff;
  font-size: 1rem;
  position: absolute;
  left: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import menuMixin from "../../mixins/menuMixin";
import accountingMixin from "../../mixins/accountingMixin";
import cartMixin from "../../mixins/cartMixin";
export default {
  mounted() {},
  data() {
    return { cartItemCount: 0 };
  },
  methods: {},
  computed: {},
  mixins: [menuMixin, accountingMixin, cartMixin],
  props: {
    tipAmount: {
      type: Number,
      required: false,
      default: 0,
    },
  },
};
</script>
